import ProductOnlyOrder from 'modules/checkout/products/product-only/ProductOnlyOrder';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';

export default function EstablishmentPageContent({ event, establishment }) {
    return (
        <Container fullyCentralized>
            <ProductOnlyOrder establishment={establishment} event={event} />
        </Container>
    )
}

const Container = styled(Column)`
  width: 100%;
  max-width: 700px;
  background-color: #fefefe;
  padding: 1rem;
  padding-bottom: 100px;

  @media screen and (min-width: ${breakpoints.lg}) {
    padding-bottom: 1rem;
  }
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.lg}) {
    max-width: 900px;
  }
`;
